import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../redux/pageSlice";
import { LoaderWrap } from "../../Component/GlobalLoader/LoaderWrap";
import "./Csv.css";
import { useVisibilityOnScroll } from "../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../Component/ReuseComponent/TCLines/TC3L";
import OurValuesBox from "../../Component/ReuseComponent/OurValuesBox/OurValuesBox";

export default function CsvArContent() {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchPageData({ page_id: 11, lang: "ar" }));
    }
  }, [dispatch, data]);

  const section1 = data.find((s) => s.section_id === "1");
  const section2 = data.find((s) => s.section_id === "2");
  const section3 = data.find((s) => s.section_id === "3");
  return (
    <>
      <LoaderWrap>
        <div className="CsvContainer">
          <section>
            <CsvS1 section={section1} />
          </section>
          <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CsvS2">
            <CsvS2 contents={section1?.contents} />
          </VisibilitySection>
          <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CsvS3">
            <CsvS3 contents={section1?.contents} />
          </VisibilitySection>
          <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CsvS4">
            <CsvS4 section={section2} contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={4} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CsvS4">
            <CsvS5 contents={section2?.contents} />
          </VisibilitySection>
          <VisibilitySection index={5} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="CsvS6">
            <CsvS6 section={section3} />
          </VisibilitySection>
        </div>
      </LoaderWrap>
    </>
  );
}
function CsvS1({ section }) {
  return (
    <>
      <div className="CsvS1">
        <TC3L Head="عن المجتمع" Title={section?.title} />
      </div>
    </>
  );
}

function CsvBoxIL({ ImgSrc, ImgAlt, Head, Title }) {
  return (
    <>
      <div className="CsvBoxIL">
        <div className="CsvBoxILP1">
          <img src={ImgSrc} alt={ImgAlt} />
        </div>
        <div className="CsvBoxILP2 ar">
          <div className="CsvBoxILP2T ar TGLo32PxPC">{Head}</div>
          <div className="CsvBoxILP2H ar TFut20PxPC" dir="rtl">
            {Title}
          </div>
        </div>
      </div>
    </>
  );
}
function CsvBoxIR({ ImgSrc, ImgAlt, Head, Title }) {
  return (
    <>
      <div className="CsvBoxIL Mob">
        <div className="CsvBoxILP2 ar">
          <div className="CsvBoxILP2T ar TGLo32PxPC">{Head}</div>
          <div className="CsvBoxILP2H ar TFut20PxPC" dir="rtl">
            {Title}
          </div>
        </div>
        <div className="CsvBoxILP1">
          <img src={ImgSrc} alt={ImgAlt} />
        </div>
      </div>
    </>
  );
}
function CsvS2({ contents }) {
  return (
    <>
      <div className="CsvS2">
        {contents?.[0] && <CsvBoxIR ImgSrc={contents[0].image} ImgAlt={contents[0].title} Head={contents[0].title} Title={contents[0].description} />}
        {/*  */}
        {contents?.[1] && <CsvBoxIL ImgSrc={contents[1].image} ImgAlt={contents[1].title} Head={contents[1].title} Title={contents[1].description} />}
      </div>
    </>
  );
}
function CsvS3({ contents }) {
  return (
    <>
      <div className="CsvS3">
        {contents?.[2] && <CsvBoxIR ImgSrc={contents[2].image} ImgAlt={contents[2].title} Head={contents[2].title} Title={contents[2].description} />}
      </div>
    </>
  );
}
function CsvS4({ section, contents }) {
  return (
    <>
      <div className="CsvS4">
        <div className="CsvS4P1">
          <TC3L Title={section?.title} />
        </div>
        <div className="CsvS4P2 ar">
          {contents?.[0] && (
            <OurValuesBox ImgSrc={contents[0].image} ImgAlt={contents[0].title} Head={contents[0].title} Title={contents[0].description} Height="27vw" />
          )}
          {/*  */}
          {contents?.[1] && (
            <OurValuesBox ImgSrc={contents[1].image} ImgAlt={contents[1].title} Head={contents[1].title} Title={contents[1].description} Height="27vw" />
          )}
        </div>
      </div>
    </>
  );
}
function CsvS5({ contents }) {
  return (
    <>
      <div className="CsvS5 ar">
        {contents?.[2] && (
          <OurValuesBox ImgSrc={contents[2].image} ImgAlt={contents[2].title} Head={contents[2].title} Title={contents[2].description} Height="27vw" />
        )}
        {/*  */}
        {contents?.[3] && (
          <OurValuesBox ImgSrc={contents[3].image} ImgAlt={contents[3].title} Head={contents[3].title} Title={contents[3].description} Height="27vw" />
        )}
      </div>
    </>
  );
}
function CsvS6({ section }) {
  return (
    <>
      <div className="CsvS6">
        <TC3L Title={section?.title} TitleWidthMob="70vw" Para={section?.description} ParaWidth="59vw" />
      </div>
    </>
  );
}
